/* eslint-disable react/react-in-jsx-scope */
import { useState } from 'react'
import { Outlet } from "react-router";
import Footer from "./footer";
import PosSidebar from "./PosSidebar";
// import Carts from "../pages/carts"
// import { CartsProvider } from '../contexts/CartContext';
import NavbarAuth from './navbarAuth';
import { Bars3Icon } from '@heroicons/react/24/outline'
import Drawer from '@mui/material/Drawer';

const PosLayout = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    // <CartsProvider>
   
    <div className="flex flex-col min-w-96">
      <div>
        <NavbarAuth />
      </div>

      <div className="h-[calc(100vh-64px)] w-full mt-16">
        <div className="flex flex-col">
          <div className="flex">
          <div>
              <Bars3Icon 
                className="absolute sm:hidden top-3 left-1 z-50 h-10 w-10 text-gray-500 hover:text-sky-500 hover:cursor-pointer"
                onClick={toggleDrawer(true)}
              />
          </div>
              <Drawer open={open} onClose={toggleDrawer(false)} onClick={toggleDrawer(false)}>
                <div className="flex w-[150px] items-center justify-center bg-slate-900">
                  <PosSidebar />
                </div>              
              </Drawer>
              <div className="hidden sm:flex w-[150px] items-start justify-center p-0 bg-slate-900">
                <PosSidebar />
              </div>
              <div className="flex-grow justify-center text-white bg-slate-600">
                <Outlet />
              </div>
              {/* <div className="">
                  <Carts />
              </div> */}
          </div>
          <Footer />
        </div>
      </div>

    </div>

    // {/* </CartsProvider> */}
  )
}

export default PosLayout